import Facilitydashboard from '@/views/Dashboard/Facilitydashboard';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AddCircle from '@mui/icons-material/AddCircle';
import Group from '@mui/icons-material/Group';

import Payments from '@/views/Managefile/Payments';
import Uploadfile from '@/views/Managefile/Uploadfile';
import {
  AccountTree,
  BusinessCenter,
  EventBusyRounded,
  MonetizationOnRounded,
  CheckRounded,
  ReportProblemRounded, // INFO: added for Resolution Center
  SummarizeRounded,
} from '@mui/icons-material';
import CreateOrEditReporting from '@/views/Reporting/CreateOrEditReporting';
import ReportingList from '@/views/Reporting/ReportingList';
import UnclaimedRefunds from '@/views/Dashboard/UnclaimedRefunds';
import FacilityTransaction from '@/views/Clients/FacilityTransaction';
import CheckPermissionsComponent from '@/views/Facilities/CheckPermissions';
import CreateOrEditBusinessUnit from '@/components/CreateOrEditBusinessUnit/CreateOrEditBusinessUnit';
import BusinessUnits from '@/views/Facilities/BusinessUnits';
import { checkOrganizationFeatures, ORGANIZATION_FEATURES } from '@/utility';
import DataMappings from '@/views/Managefile/data-mappings/DataMappings';
import CreateOrEditDataMappings from '@/views/Managefile/data-mappings/CreateOrEditDataMappings';
import CreateRefund from '@/views/Facilities/CreateRefund';
import Approvals from '@/views/Facilities/Approvals';
import Exceptions from '@/views/Facilities/Exceptions';
import Audience from '@/views/Audience/Audience';
import CreateOrEditAudience from '@/views/Audience/CreateOrEditAudience';
import InternalUserManagement from '@/views/Facilities/InternalUserManagement/InternalUserManagement';

const dashboardRoutes = [
  {
    path: '/facilitydashboard',
    name: 'Dashboard',
    translationKey: 'sidebar.dashboard',
    rtlName: 'قائمة الجدول',
    icon: AssessmentIcon,
    component: Facilitydashboard,
    layout: '/facility',
  },
  {
    path: '/create-business-unit',
    name: 'Dashboard',
    rtlName: 'قائمة الجدول',
    component: () => (
      <CheckPermissionsComponent parentKey='business_units'>
        <CreateOrEditBusinessUnit />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: true,
  },
  {
    path: '/edit-business-unit/:id',
    name: 'Dashboard',
    rtlName: 'قائمة الجدول',
    component: () => (
      <CheckPermissionsComponent parentKey='business_units'>
        <CreateOrEditBusinessUnit />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: true,
  },
  {
    path: '/facility-transaction',
    name: 'Payments',
    translationKey: 'sidebar.payments',
    rtlName: 'قائمة الجدول',
    icon: MonetizationOnRounded,
    component: () => (
      <CheckPermissionsComponent parentKey='transaction_page'>
        <FacilityTransaction />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
  },
  {
    path: '/create-payment',
    name: 'Create Payment',
    translationKey: 'sidebar.createPayment',
    rtlName: 'إنشاء استرداد',
    icon: AddCircle,
    component: () => (
      <CheckPermissionsComponent parentKey='create_payment'>
        <CreateRefund />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: !checkOrganizationFeatures(
      ORGANIZATION_FEATURES.showCreatePaymentPage,
    ),
  },
  {
    path: '/uploadrefundfile',
    name: 'Upload Refund File',
    translationKey: 'sidebar.uploadRefundFile',
    rtlName: 'قائمة الجدول',
    icon: CloudUploadIcon,
    component: () => (
      <CheckPermissionsComponent parentKey='refundee_file'>
        <Uploadfile />
      </CheckPermissionsComponent>
    ),

    layout: '/facility',
  },
  {
    path: '/approvals',
    name: 'Approvals',
    translationKey: 'sidebar.approvals',
    rtlName: 'الموافقات',
    icon: CheckRounded,
    component: () => (
      <CheckPermissionsComponent parentKey='approvals'>
        <Approvals role='facility' />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: !checkOrganizationFeatures(
      ORGANIZATION_FEATURES.showApprovalsPage,
    ),
  },
  {
    path: '/exceptions',
    name: 'Resolution Center',
    translationKey: 'sidebar.resolutionCenter',
    rtlName: 'قائمة الجدول',
    icon: ReportProblemRounded,
    component: () => (
      <CheckPermissionsComponent parentKey='exceptions'>
        <Exceptions />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
  },
  {
    path: '/business-units',
    name: 'Business Units',
    translationKey: 'sidebar.businessUnits',
    rtlName: 'قائمة الجدول',
    icon: BusinessCenter,
    component: () => (
      <CheckPermissionsComponent parentKey='business_units'>
        <BusinessUnits />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: !checkOrganizationFeatures(
      ORGANIZATION_FEATURES.showBusinessUnitsPage,
    ),
  },
  {
    path: '/audience',
    name: 'Audience',
    translationKey: 'sidebar.audience',
    rtlName: 'جمهور',
    icon: AccountTree,
    component: () => (
      <CheckPermissionsComponent parentKey='audience'>
        <Audience />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
  },
  {
    path: '/internal-users',
    name: 'Facility Users',
    translationKey: 'sidebar.facilityUsers',
    rtlName: 'مستخدمو المنشأة',
    icon: Group,
    component: () => (
      <CheckPermissionsComponent parentKey='facility_user_management'>
        <InternalUserManagement />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: !checkOrganizationFeatures(
      ORGANIZATION_FEATURES.showFacilityManagementPage,
    ),
  },
  {
    path: '/transaction',
    name: 'Refund Reporting',
    translationKey: 'sidebar.refundReporting',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: CloudDownloadIcon,
    component: () => (
      <CheckPermissionsComponent parentKey='refund_reporting'>
        <Payments />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
  },
  {
    path: '/manage-data-mapping',
    name: 'Manage Data Mapping',
    translationKey: 'sidebar.manageDataMapping',
    rtlName: 'قائمة الجدول',
    icon: AccountTree,
    component: () => (
      <CheckPermissionsComponent parentKey='data_mapping'>
        <DataMappings />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
  },
  {
    path: '/create-data-mapping',
    name: 'Manage Data Mapping',
    rtlName: 'قائمة الجدول',
    icon: AccountTree,
    component: () => (
      <CheckPermissionsComponent parentKey='data_mapping'>
        <CreateOrEditDataMappings />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: true,
  },
  {
    path: '/edit-data-mapping/:id',
    name: 'Manage Data Mapping',
    rtlName: 'قائمة الجدول',
    icon: AccountTree,
    component: () => (
      <CheckPermissionsComponent parentKey='data_mapping'>
        <CreateOrEditDataMappings />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: true,
  },
  {
    path: '/unclaimed-refunds',
    name: 'Unclaimed Refunds',
    translationKey: 'sidebar.unclaimedRefunds',
    rtlName: 'قائمة الجدول',
    icon: EventBusyRounded,
    component: () => (
      <CheckPermissionsComponent parentKey='unclaimed_refunds'>
        <UnclaimedRefunds />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
  },

  {
    path: '/reporting',
    name: 'Reporting',
    translationKey: 'sidebar.reporting',
    rtlName: 'التقارير',
    icon: SummarizeRounded,
    component: () => <ReportingList />,
    layout: '/facility',
    featureFlag: 'new-outbound-reports',
  },
  {
    path: '/create-reporting',
    name: 'Create Reporting',
    component: () => <CreateOrEditReporting />,
    layout: '/facility',
    invisible: true,
  },
  {
    path: '/edit-reporting/:id',
    name: 'Edit Reporting',
    component: () => <CreateOrEditReporting />,
    layout: '/facility',
    invisible: true,
  },
  {
    path: '/create-audience',
    name: 'Create Audience',
    rtlName: 'إنشاء جمهور',
    component: () => (
      <CheckPermissionsComponent parentKey='audience'>
        <CreateOrEditAudience />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: true,
  },
  {
    path: '/edit-audience/:id',
    name: 'Edit Audience',
    rtlName: 'تعديل جمهور',
    component: () => (
      <CheckPermissionsComponent parentKey='audience'>
        <CreateOrEditAudience />
      </CheckPermissionsComponent>
    ),
    layout: '/facility',
    invisible: true,
  },
];

export const facilityRoutes = dashboardRoutes;
